// src/pages/support/components/RollbackTransferModal.jsx
import React from "react";
import Modal from "./Modal";

function RollbackTransferModal({ playerData, isRollingBack, error, onClose, onConfirm }) {
  if (!playerData) return null;

  return (
    <Modal title="بازگشت انتقال بازیکن" onClose={onClose}>
      <div className="space-y-4">
        {error && <div className="text-red-400 text-sm">{error}</div>}

        <div
          className="rounded-xl border p-4"
          style={{ borderColor: "rgba(139,92,246,0.5)", backgroundColor: "rgba(139,92,246,0.08)" }}
        >
          <p className="text-gray-200">
            آیا از بازگشت انتقال بازیکن <span className="text-white font-semibold">{playerData.username}</span> مطمئن هستید؟
          </p>
          <p className="text-gray-400 text-sm mt-1">
            این عملیات آخرین انتقال این بازیکن را لغو می‌کند و او را به تیم قبلی برمی‌گرداند.
          </p>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-xl text-gray-200 border"
            style={{ borderColor: "rgba(55,65,81,0.6)", backgroundColor: "rgba(17,24,39,0.6)" }}
          >
            انصراف
          </button>
          <button
            onClick={onConfirm}
            disabled={isRollingBack}
            className={`px-4 py-2 rounded-xl text-white ${isRollingBack ? "opacity-70" : ""}`}
            style={{ backgroundColor: "#8b5cf6" }}
          >
            {isRollingBack ? "در حال بازگشت..." : "↩ تأیید بازگشت انتقال"}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default RollbackTransferModal;